import toast2 from "react-hot-toast";
import { formatDistanceToNow } from "date-fns";
import {
  isTokenPresent,
  removeLocalStorage,
  setLocalStorage,
} from "./userHelper";
import { download_file } from "../pages/resumeDetails/helper";
export function getBaseApiURL() {
  return process.env.REACT_APP_API_BASE;
}

const errorHanlder = (err) => {
  /* 
 THis Function handle the 3 to 4 states of errors:
 1. if error has a string 
 2. if error has a object and response key exist in object.
 3. if response key exist and data key exist in object.
 4. if response key, data key, detail key exist in object.
 5. response key, data key, detail key, user_message key exist in object.
  */
  console_log("err", err, typeof err);
  if (typeof err === "string") return err;
  if (err.response) {
    if (err.response.data) {
      if (err.response.data.detail) {
        if (err.response.data.detail.user_message) {
          return err.response.data.detail?.user_message;
        } else {
          return err.response.data.detail;
        }
      } else {
        console_log("rr.response.data.detail not found....");
        return err.response.data;
      }
    } else {
      console_log("rr.response.data not found....");
      return err.response;
    }
  } else {
    console_log("rr.response not found....", err);
    return err.message;
  }
};
export function showToast(
  message = "Data Sucessfully Added",
  type = "success"
) {
  //toast 1
  // if (type == "success") toast(message);
  // else toast.error(message);

  //tost 2
  if (type == "success") toast2(message);
  else toast2.error(errorHanlder(message));
}

export function create_error_message(error) {
  return error.response.data.detail;
}

export function convertBooleansToStrings(data) {
  // Check if the input is an object or an array
  if (Array.isArray(data)) {
    // Iterate over each element in the array
    return data.map((item) => convertBooleansToStrings(item));
  } else if (typeof data === "object" && data !== null) {
    // Iterate over each property of the object
    const result = {};
    for (const key in data) {
      if (data.hasOwnProperty(key)) {
        // Recursively apply conversion to nested objects or arrays
        result[key] = convertBooleansToStrings(data[key]);
      }
    }
    return result;
  } else if (typeof data === "boolean") {
    // Convert boolean values to string equivalents
    return data ? "true" : "false";
  } else {
    // Return non-boolean values as they are
    return data;
  }
}

export const HumanReadableDate = (isoDate) => {
  // console_log('isoDate', isoDate);
  if (!isoDate) return;

  // Convert ISO date (UTC) to user's local time
  const date = new Date(isoDate);
  const localDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);

  // Format the date as a human-readable string
  let final_date = formatDistanceToNow(localDate) + " ago";
  final_date = final_date.replace("about ", "");

  return final_date;
};

export const ReadableDate = (isoDate) => {
  if (!isoDate) return;

  // Convert ISO date (UTC) to user's local time
  const date = new Date(isoDate);
  const localDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);

  // Format the date as MM-DD-YYYY
  const month = String(localDate.getMonth() + 1).padStart(2, "0"); // Months are zero-based
  const day = String(localDate.getDate()).padStart(2, "0");
  const year = localDate.getFullYear();

  return `${month}-${day}-${year}`;
};

export const console_log = (name, value, value2 = "") => {
  console.log(name, value, value2);
};
export const console_loge = (name, value) => {
  console.log(name, value);
};

export function limitText(text, maxLength) {
  if (typeof text !== "string") {
    console.error("Input is not a string:", text);
    return "";
  }

  if (text.length <= maxLength) {
    return text; // No truncation needed
  }

  return text.slice(0, maxLength) + "...";
}

export function isEmptyObject(obj) {
  return JSON.stringify(obj) === "{}";
}
export const downloadButtonClicked = async (
  downloadUrl,
  slug,
  resumeId,
  setIsDownloading,
  navigate,
  setDownloadButtonLoadingState
) => {
  if (isTokenPresent()) {
    setIsDownloading(true);
    setDownloadButtonLoadingState &&
      setDownloadButtonLoadingState((prev) => ({
        ...prev,
        [downloadUrl]: true,
      }));
    try {
      console.log(downloadUrl);
      const downloadSuccessful = await download_file(downloadUrl);
      removeLocalStorage("downlaodResumeId");
      removeLocalStorage("downloadResumeSlug");
      removeLocalStorage("downloadResumeUrl");
    } catch (error) {
    } finally {
      setIsDownloading(false);
      setDownloadButtonLoadingState &&
        setDownloadButtonLoadingState((prev) => ({
          ...prev,
          [downloadUrl]: false,
        }));
    }
  } else {
    setLocalStorage("downloadResumeUrl", downloadUrl);
    setLocalStorage("downloadResumeSlug", slug);
    setLocalStorage("downloadResumeId", resumeId);
    navigate("/login");
  }
};
